{
    "gEJIW": {
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "key": "gEJIW",
        "tag": "spawn"
    },
    "7sJFA": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "key": "7sJFA",
        "tag": "spawn"
    }
}